<!--
*参考V-Calendar进行二次封装
*地址：https://vcalendar.io/api/calendar.html
*主要实现对日历文本文字的自定义
*by linlei 2020-05-12
ii8n
en-US
zh-CN
 -->
<template>
  <div class="custom-calendar-box">
    <vc-calendar
      ref="calendar"
      :attributes="attrs"
      :highlight="{borderRadius: '10%'}"
      :max-date="maxDate"
      :locale=" language == 'zh' ? 'zh-CN': 'en-US'"
      @dayclick="dayClick"
      @transition-end="transitionEnd"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: 'IntestCalendar',
  props: {
    attributes: {
      type: Array,
      default: () => [
        {
          key: 'today',
          highlight: true,
          dates: this.getDates(new Date())
        }
      ]
    },
    moreDate: {
      type: Boolean,
      default: false
    },
    preventEvent: {
      type: Boolean,
      default: false
    },
    maxDate: {
      type: Date,
      default: ()=>null
    }
  },
  computed: {
    ...mapGetters(['language'])
  },
  data() {
    return {
      attrs: []
    }
  },
  watch: {
    attributes: {
      handler(val) {
        this.attrs = [...val]
      },
      deep: true
    }
  },
  created() {
    this.attrs = [...this.attributes]
  },
  mounted() {
    this.setCalendarText()
  },
  methods: {
    getCalendar() {
      return this.$refs.calendar
    },
    getDates(dates) {
      const years = new Date(dates).getFullYear()
      const months = new Date(dates).getMonth() + 1 > 9 ? new Date(dates).getMonth() + 1 : '0' + (new Date(dates).getMonth() + 1)
      const days = new Date(dates).getDate() > 9 ? new Date(dates).getDate() : '0' + new Date(dates).getDate()
      const YMD = `${years}-${months}-${days}`
      return YMD
    },
    dayClick(e) {
      if (this.preventEvent) return
      if(new Date(e.id).getTime()>new Date(this.maxDate).getTime()) return
      this.$emit('click', e)
      this.setCalendar(e)
    },
    transitionEnd(e) {
      this.$emit('transition-end', e)
      this.setCalendarText()
    },
    setCalendar(e) {
      // 判断是否多选时间日历
      if (!this.moreDate) {
        this.attrs.splice(index, 1, {
          key: e.id,
          highlight: true,
          dates: e.id
        })
        return
      }
      const index = this.attrs.findIndex(item => e.id === this.getDates(item.dates))
      if (index > -1) {
        // console.log('点击了选择的日期')
        this.attrs.splice(index, 1)
      } else {
        this.attrs.push({
          key: e.id,
          highlight: true,
          dates: e.id
        })
      }
    },
    setCalendarText() {
      if (this.attrs && this.attrs.length > 0) {
        this.$nextTick(() => {
          const pageDays = this.$refs.calendar.getPageDays()
          const domList = this.$refs.calendar.$el.querySelectorAll('.vc-day-content')
          domList.forEach(dom => {
            const index = pageDays.findIndex(item => item.ariaLabel === dom.getAttribute('aria-label'))
            if (index > -1) {
              dom['date-id'] = pageDays[index].id
              dom['date-day'] = pageDays[index].day
              const attrsIndex = this.attrs.findIndex(v => {
                return v.dates == dom['date-id']
              })
              if (attrsIndex > -1) {
                this.attrs[attrsIndex].mileage && (dom.innerText = `${dom['date-day']}\n${this.attrs[attrsIndex].mileage}`)
              }
            }
          })
        })
      } else {
        return
      }
    }
  }
}

</script>

<style lang="scss" scoped>

</style>
